import { useQuery, useInfiniteQuery } from "@tanstack/react-query"
import {
  getOrderDeliverySummary,
  getMissingOrmList,
  getUndeliveredList,
  getReroutedList,
  getStudyDetail,
} from "../api/orderDeliveryInsights"

export const useOrderDeliverySummary = ({ filters = {} } = {}) =>
  useQuery({
    queryKey: ["odi-summary", filters],
    queryFn: () => getOrderDeliverySummary({ filters }),
    retry: false,
    select: (data) => data?.data,
  })

const getNextPageParam = (lastPage) => {
  if (!lastPage) return undefined
  const { page, limit, total } = lastPage
  return page * limit < total ? page + 1 : undefined
}

export const useMissingOrmInfinite = ({ limit = 25, filters = {} } = {}) =>
  useInfiniteQuery({
    queryKey: ["odi-missing-orm", limit, filters],
    queryFn: ({ pageParam = 1 }) =>
      getMissingOrmList({ page: pageParam, limit, filters }),
    initialPageParam: 1,
    getNextPageParam,
    retry: false,
  })

export const useUndeliveredInfinite = ({ limit = 25, filters = {} } = {}) =>
  useInfiniteQuery({
    queryKey: ["odi-undelivered", limit, filters],
    queryFn: ({ pageParam = 1 }) =>
      getUndeliveredList({ page: pageParam, limit, filters }),
    initialPageParam: 1,
    getNextPageParam,
    retry: false,
  })

export const useReroutedInfinite = ({ limit = 25, filters = {} } = {}) =>
  useInfiniteQuery({
    queryKey: ["odi-rerouted", limit, filters],
    queryFn: ({ pageParam = 1 }) =>
      getReroutedList({ page: pageParam, limit, filters }),
    initialPageParam: 1,
    getNextPageParam,
    retry: false,
  })

export const useStudyDetail = ({ accessionNo, issuer } = {}) =>
  useQuery({
    queryKey: ["odi-detail", accessionNo, issuer],
    queryFn: () => getStudyDetail({ accessionNo, issuer }),
    retry: false,
    enabled: !!accessionNo && !!issuer,
    select: (data) => data?.data,
  })
